import React from "react";
import { CONSTANT } from "../../../../../constant/Constant";
import { GetDateDetails } from "../../../../../utils/GetDateDetails";

export default function TopSession({ data }) {
  const date = GetDateDetails(data.datetime);

  return (
    <div className="w-full">
      <div className=" flex justify-center items-center pt-10">
        <img
          src={`${CONSTANT.UI_URL}flower/${data.flower}`}
          alt="flower"
          className="h-40 "
        />
      </div>
      <div className="flex justify-center items-center">
        <p className="text-gray font-semibold text-xl text-center opacity-75">
          {data.description}
        </p>
      </div>

      <div className="text-center py-10 relative flex flex-col justify-center items-center">
        <p className="text-white font-bold text-8xl  font-tangerine">
          {data.bridesName}
        </p>
        <p className="text-white font-bold text-2xl text-center w-full font-tangerine">
          With
        </p>
        <p className="text-white font-bold text-8xl  font-tangerine">
          {data.groomsName}
        </p>
      </div>

      <p className="text-white text-center font-bubbles font-bold text-3xl">
        {" "}
        {date.day.toUpperCase()} {date.dayStr} {date.month.toUpperCase()}{" "}
        {date.year}, {date.time}
      </p>
    </div>
  );
}
